import { render, staticRenderFns } from "./HeaderV3.vue?vue&type=template&id=5140dbf8&scoped=true&"
import script from "./HeaderV3.vue?vue&type=script&lang=js&"
export * from "./HeaderV3.vue?vue&type=script&lang=js&"
import style0 from "./HeaderV3.vue?vue&type=style&index=0&id=5140dbf8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5140dbf8",
  null
  
)

export default component.exports